const formatDate = (dateString) => {
  const date = new Date(`${dateString}`);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export default formatDate;
